import httpClient from "../http/http-client";
import { IGoodCategory, IGoodCategoryImportPreview, IGoodCategoryImportResult, IGoodCategoryImportRow, IPostGoodCategory } from './good-category.model';

export default class GoodCategoryService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IGoodCategory[]> {
    return this.http.get(`good-category`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllForCatalogue(queryString?: string): Promise<any> {
    return this.http.get(`good-category/catalogue${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IGoodCategory[] }> {
    return this.http.get(`good-category?nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOne(goodCategoryId: string): Promise<IGoodCategory> {
    return this.http.get(`good-category/${goodCategoryId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(goodCategory: IPostGoodCategory): Promise<IGoodCategory> {
    return this.http.post(`good-category`, goodCategory)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(goodCategoryId: string, goodCategory: IPostGoodCategory): Promise<IGoodCategory> {
    return this.http.patch(`good-category/${goodCategoryId}`, goodCategory)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async delete(goodCategoryId: string): Promise<IGoodCategory> {
    return this.http.delete(`good-category/${goodCategoryId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getCategoryOptions(queryString?: string): Promise<any> {
    return this.http.get(`good-category/categories${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async checkIfGoodCategoryInUse(goodCategoryId: string): Promise<any> {
    return this.http.get(`good-category/check-status/${goodCategoryId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // The spreadsheet template for a product category import: Read Me tab plus the columns to fill in.
  async getImportTemplate(): Promise<any> {
    return this.http.get(`good-category/import/template`, { responseType: 'blob' })
      .then(response => {
        return response
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  // Parse an uploaded product category sheet and return what it would do. Writes nothing: the
  // caller posts the reviewed rows to importRows once the user has confirmed them.
  async previewImport(file: File): Promise<IGoodCategoryImportPreview> {
    const form = new FormData();
    form.append('files', file);
    return this.http.post(`good-category/import/preview`, form)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async importRows(rows: Pick<IGoodCategoryImportRow, 'rowNumber' | 'category' | 'subCategoryOne' | 'subCategoryTwo' | 'goodCategoryReference'>[]): Promise<IGoodCategoryImportResult> {
    return this.http.post(`good-category/import`, { rows })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

}
